import { ACCESS_TOKEN, USER_DATA } from './apiConstant';

/**
 * Stores the access token in localStorage
 * @param token - JWT or access token string
 */
export const setToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

/**
 * Retrieves the access token from localStorage
 * @returns The stored token, or null if not found
 */
export const getToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN);
};

/**
 * Removes the access token from localStorage
 */
export const removeToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN);
};

export const removeUserFromLocalStorage = (): void => {
  localStorage.removeItem(USER_DATA);
};

export const getUserFromLocalStorage = (): string | null => {
  return localStorage.getItem(USER_DATA);
};

export const setUserFromLocalStorage = (user: string): void => {
  localStorage.setItem(USER_DATA, user);
};